import React, { useEffect, useState, Fragment } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { CLICKED, CMSPath, EXIT } from "../../../config/constant";
import { setGoHome } from "../../action/homeAction";
import EventCard from "./EventCard";



const WayActivity2 = (props) => {
  const [allCategories, setAllCategories] = useState([]);
  const [isAllFilterSelected, setIsAllFilterSelected] = useState(props.selectedData.selectedCategory.name == "all");
  const [visibleEvents, setVisibleEvents] = useState([]);

  const eventsData = props.eventsData;
  const { t } = props;

  const extractCategories = () => Object.keys(eventsData).map(cat => ({ name: cat }));

  const extractEvents = () => {
    let events = [];
    if (props.selectedData.selectedCategory.name == "all") {
      const categories = Object.keys(eventsData).map(cat => ({ name: cat }));
      categories.forEach(cat => {
        events = [...events, ...eventsData[cat.name]];
      })
      return events;
    }
    console.log("Before putting the data in the event cat is " + props.selectedData.selectedCategory.name)
    events = eventsData[props.selectedData.selectedCategory.name] || [];
    console.log("Events after the selection " + JSON.stringify(events));
    return events;
  }

  // const getCustomQuestions = (id) => {
  //   const defaultQuestions = [
  //     {
  //       id: "firstName",
  //       prompt: "First name",
  //       fieldType: "input",
  //       options: null,
  //       termsAndConditions: null,
  //       config: {
  //         isRequired: true,
  //         scope: "purchaser",
  //         conditionsMatchType: null,
  //         isActive: true,
  //         conditions: null,
  //         order: 0,
  //         isDefault: true,
  //         disabled: false
  //       }
  //     },
  //     {
  //       id: "lastName",
  //       prompt: "Last name",
  //       fieldType: "input",
  //       options: null,
  //       termsAndConditions: null,
  //       config: {
  //         isRequired: true,
  //         scope: "purchaser",
  //         conditionsMatchType: null,
  //         isActive: true,
  //         conditions: null,
  //         order: 1,
  //         isDefault: true,
  //         disabled: false
  //       }
  //     }
  //   ];
  //   console.log("eventsData", eventsData);

  //   let customQuestions;
  //   for(const eventsPerCategory of Object.values(eventsData)){

  //     const selectedEvent = eventsPerCategory.find((eve) => eve.id == id);
  //     if(selectedEvent ) { customQuestions = selectedEvent.customQuestions; break; }
  //   }

  //   console.log(customQuestions, "customQuestions")
    
  //   // Merge default + API questions
  //   const mergedQuestions = [...defaultQuestions, ...customQuestions];
  //   return mergedQuestions;
  // }

  const handleEventClick = (event) => {
    console.log("The data of the api is like " + JSON.stringify(eventsData));
    props.handleSelectedDataChange({
      event
    })
    props.goNextPage({type:"EVENT_SELECTED", payload:{event}});
  }

  const handleSelectedCategory = (cat) => {
    props.handleSelectedDataChange({
      selectedCategory: cat
    });
  }

  useEffect(() => {
    setVisibleEvents(extractEvents());
    setAllCategories(extractCategories());
  }, []);

  useEffect(() => {
    setVisibleEvents(extractEvents());
    console.log("Selected category" + JSON.stringify(props.selectedData.selectedCategory))
  }, [props.selectedData.selectedCategory])

  return (
    <>
       <header className="inner-pages w-footer subpages">
                        <a className="button-back" onClick={props.goPreviousPage}></a>
                        <div className="heading align-center">
                        <div class="header">
                            <p className="text">{t("way_activity.common.header_text")}</p>
                        </div>
                        </div>
                </header>
      <section class="widgets activity-listing">
        <div class="">
          <div class="widget-header-title">{t("way_activity.events_page.header_title")}</div>
        </div>
        {
          eventsData ?
          <>
            <div class="tab-selection">
              <ul class="tabs">
                <li
                  class={isAllFilterSelected ? "tab-selected" : ""}
                  onClick={() => {
                    setIsAllFilterSelected(true);
                    handleSelectedCategory({ name: "all" });
                  }}>
                  <a>
                    {t("way_activity.events_page.tab_all")}
                  </a>
                </li>
                {allCategories && allCategories.map((cat, index) => {
                  return (
                    <li key={cat.name + index}
                      class={
                        !isAllFilterSelected &&
                          cat.name == props.selectedData.selectedCategory.name
                          ? "tab-selected"
                          : ""
                      }
                      onClick={() => {
                        setIsAllFilterSelected(false);
                        handleSelectedCategory(cat);
                      }}
                    >
                      <a>
                        {cat.name}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>

            <div class="events-container">
              {
                visibleEvents && visibleEvents.map((event,index) => {
                  return (
                    <div onClick={() => {
                      handleEventClick(event)
                    }}
                      key={index}
                    >
                      <EventCard
                        eventImage={event && event.coverMedia && event.coverMedia.uri && event.coverMedia.uri.original
                          ? event.coverMedia.uri.original
                          : null}
                        hostImage={
                          event && event.hostedBy && event.hostedBy.profilePicture && event.hostedBy.profilePicture.uri
                            ? event.hostedBy.profilePicture.uri["256w"]
                            : null
                        }
                        hostName={
                          event && event.hostedBy && event.hostedBy.firstName
                            ? event.hostedBy.firstName + " " + (event.hostedBy.lastName || "")
                            : ""
                        }
                        firstAvailableScheduledDate={
                          event && event.firstAvailableDate && event.firstAvailableDate.scheduledDate
                            ? event.firstAvailableDate.scheduledDate
                            : ""
                        }
                        title={event && event.title ? event.title : ""}
                        price={
                          event  && event.startingPrice 
                        }
                        isRecurringEvent={event.kind == "event"}
                        dateFormat = {props.dateFormat}
                      />
                    </div>
                  )
                })
              }
            
            </div>
          </>
          :
          <div>
            {t("way_activity.events_page.no_events")}
          </div>
        }
      </section>
    </>
  )
}


const mapStateToProps = (state) => {
  return {
    installedAppVersion: state.store.installedAppVersion,
    installedAppBuildNo: state.store.installedAppBuildNo,
    currentHomePage: state.store2.currentHomePage,
    currentWidgetObj: state.store.sideNavBar.currentWidget,
    guestDetail: state.store.home.guestDetails,
    guestIsLoggedIn: state.store2.guestIsLoggedIn,
    currentWidgets: state.store.sideNavBar.currentWidget,
    dateFormat: state.store.home.clientConfig.extraConfigParam
      ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
      : "",
    // timeFormat: state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,
    serverTimeDate: state.store.home.serverTimeDate.date,
    serverDate: state.store.home.serverTimeDate,
  };
};

export default connect(mapStateToProps,
  {  })(
    withTranslation("translations")(WayActivity2)
  );
